<template>
  <div class="dashboard-container">
    <div class="button-container">
      <b-button class="button-back" @click="$router.push('/dashboardcsi', () => {})">back</b-button>
      <div class="filter-container">
        <span class="filter-label">Filter : </span>
        <b-form-select
          :options="[
            {value : null, text : 'ALL'},
            {value : 'BC', text : 'BCE'},
            {value : 'GEMS', text : 'GEMS'},
          ]"
          v-model="filterCompany"
          class="filter-company"
        ></b-form-select>
      </div>
    </div>
    <div class="table-container">
      <b-table striped responsives :fields="fields" :items="filterGroup(sangat_memuaskan)" class="cat-sm" sticky-header="100%">
        <template v-slot:thead-top>
          <b-tr>
              <b-th colspan="5" class="text-center bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff">Sangat Memuaskan</b-th>
            </b-tr>
        </template>
        <template v-slot:cell(no)="data">
          <div>
            <span>{{ data.index + 1 }}</span>
          </div>
        </template>

        <template v-slot:cell(CONTRACT_AMOUNT)="data">
          <div class="value-contract">
            <span>{{ formatNumber(data.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(SCORE)="data">
          <div>
            <span>{{ formatScore(data.value) }}</span>
          </div>
        </template>
      </b-table>

      <b-table striped responsives :fields="fields" :items="filterGroup(memuaskan)" class="cat-sm" sticky-header="100%">
        <template v-slot:thead-top>
          <b-tr>
              <b-th colspan="5" class="text-center bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff">Memuaskan</b-th>
            </b-tr>
        </template>
        <template v-slot:cell(no)="data">
          <div>
            <span>{{ data.index + 1 }}</span>
          </div>
        </template>

        <template v-slot:cell(CONTRACT_AMOUNT)="data">
          <div class="value-contract">
            <span>{{ formatNumber(data.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(SCORE)="data">
          <div>
            <span>{{ formatScore(data.value) }}</span>
          </div>
        </template>
      </b-table>

      <b-table striped responsives :fields="fields" :items="filterGroup(cukup_memuaskan)" class="cat-sm" sticky-header="100%">
        <template v-slot:thead-top>
          <b-tr>
              <b-th colspan="5" class="text-center bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff"> Cukup Memuaskan</b-th>
            </b-tr>
        </template>
        <template v-slot:cell(no)="data">
          <div>
            <span>{{ data.index + 1 }}</span>
          </div>
        </template>

        <template v-slot:cell(CONTRACT_AMOUNT)="data">
          <div class="value-contract">
            <span>{{ formatNumber(data.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(SCORE)="data">
          <div>
            <span>{{ formatScore(data.value) }}</span>
          </div>
        </template>
      </b-table>
      <b-table striped responsives :fields="fields" :items="filterGroup(tidak_memuaskan)" class="cat-sm" sticky-header="100%">
        <template v-slot:thead-top>
          <b-tr>
              <b-th colspan="5" class="text-center bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff">Tidak Memuaskan</b-th>
            </b-tr>
        </template>
        <template v-slot:cell(no)="data">
          <div>
            <span>{{ data.index + 1 }}</span>
          </div>
        </template>

        <template v-slot:cell(CONTRACT_AMOUNT)="data">
          <div class="value-contract">
            <span>{{ formatNumber(data.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(SCORE)="data">
          <div>
            <span>{{ formatScore(data.value) }}</span>
          </div>
        </template>
      </b-table>

      <b-table striped responsives :fields="fields" :items="filterGroup(sangat_buruk)" class="cat-sm" sticky-header="100%">
        <template v-slot:thead-top>
          <b-tr>
              <b-th colspan="5" class="text-center bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.12); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff">Sangat Buruk</b-th>
            </b-tr>
        </template>
        <template v-slot:cell(no)="data">
          <div>
            <span>{{ data.index + 1 }}</span>
          </div>
        </template>

        <template v-slot:cell(CONTRACT_AMOUNT)="data">
          <div class="value-contract">
            <span>{{ formatNumber(data.value) }}</span>
          </div>
        </template>

        <template v-slot:cell(SCORE)="data">
          <div>
            <span>{{ formatScore(data.value) }}</span>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
  import numeral from 'numeral'
  export default {
    name : 'csiDetailDashboard',
    data(){
      return {
        filterCompany : null,
        sangat_memuaskan : null,
        memuaskan : null,
        cukup_memuaskan : null,
        tidak_memuaskan : null,
        sangat_buruk : null,
        fields : [
          {key : 'no', label : 'No', thClass : 'bg-subhead'},
          {key : 'SERVER', label : 'Company Group', thClass : 'bg-subhead'},
          {key : 'VENDOR_NAME', label : 'Vendor Name', thClass : 'bg-subhead'},
          {key : 'SCORE', label : 'Score', thClass : 'bg-subhead'},
        ]
      }
    },
    created(){
      const self = this
      self.$store.dispatch('toggleSidebar', false)
      this.detailClassification()
    },
    methods : {
      formatScore(value){
        if(value){
          return Number(value).toFixed(0)
        }
        return '-'
      },
      formatNumber(value){
        if(value){
          let newNumber = numeral(value).format('0,0.00')
          let convertNewNumber = ''
          newNumber.split('').map(list => {
            if(list == ','){
              convertNewNumber += '.'
            } else if(list == '.') {
              convertNewNumber += ','
            } else {
              convertNewNumber += list
            }
          })
          return convertNewNumber
        }
        return '-'
      },
      filterGroup(value){
        if(value && value.length > 0 && this.filterCompany){
          const company = value.filter(item => item.SERVER == this.filterCompany)
          if(company){
            return company
          }
          return null
        }
        return value
      },
      detailClassification(){
        const detail = this.$store.state.csiDashboardDetail
        let sangat_memuaskan = []
        let memuaskan = []
        let cukup_memuaskan = []
        let tidak_memuaskan = []
        let sangat_buruk = []
        detail && detail.map(list => {
          if(list.GRADE == 'SANGAT MEMUASKAN'){
            sangat_memuaskan.push(list)
          }
          if(list.GRADE == 'MEMUASKAN'){
            memuaskan.push(list)
          }
          if(list.GRADE == 'CUKUP MEMUASKAN'){
            cukup_memuaskan.push(list)
          }
          if(list.GRADE == 'TIDAK MEMUASKAN'){
            tidak_memuaskan.push(list)
          }
          if(list.GRADE == 'SANGAT BURUK'){
            sangat_buruk.push(list)
          }
        })

        this.sangat_memuaskan = sangat_memuaskan
        this.memuaskan = memuaskan
        this.cukup_memuaskan = cukup_memuaskan
        this.tidak_memuaskan = tidak_memuaskan
        this.sangat_buruk = sangat_buruk
      }
    }
  }
</script>

<style lang="scss">
@import "~/assets/scss/components/dashboarddetailspm.scss";
</style>